export enum NewsTagContextEnum {
  Free = '',
  Class = 'Class',
  Subclass = 'Subclass',
  Subfamily = 'Subfamily',
  Model = 'Model',
}
